export default __webpack_public_path__ + "components/tooltips/static/chill-9c0744214410399056ad10ab75dbb660.jpg";